/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsPreview,
    SharedserviceMelcoModelsPreviewFromJSON,
    SharedserviceMelcoModelsPreviewFromJSONTyped,
    SharedserviceMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoFusionModelsDefaultImage
 */
export interface SharedserviceMelcoFusionModelsDefaultImage {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    view_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    color_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    color_hex?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    publish_state?: number;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsPreview>}
     * @memberof SharedserviceMelcoFusionModelsDefaultImage
     */
    previews?: Array<SharedserviceMelcoModelsPreview> | null;
}

export function SharedserviceMelcoFusionModelsDefaultImageFromJSON(json: any): SharedserviceMelcoFusionModelsDefaultImage {
    return SharedserviceMelcoFusionModelsDefaultImageFromJSONTyped(json, false);
}

export function SharedserviceMelcoFusionModelsDefaultImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoFusionModelsDefaultImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'view_name': !exists(json, 'view_name') ? undefined : json['view_name'],
        'color_name': !exists(json, 'color_name') ? undefined : json['color_name'],
        'color_hex': !exists(json, 'color_hex') ? undefined : json['color_hex'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(SharedserviceMelcoModelsPreviewFromJSON)),
    };
}

export function SharedserviceMelcoFusionModelsDefaultImageToJSON(value?: SharedserviceMelcoFusionModelsDefaultImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'view_name': value.view_name,
        'color_name': value.color_name,
        'color_hex': value.color_hex,
        'publish_state': value.publish_state,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(SharedserviceMelcoModelsPreviewToJSON)),
    };
}


